import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Lock } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center border border-[#FFD700]/30 rounded-full">
            <Lock size={28} weight="duotone" className="text-[#FFD700]" />
          </div>
          <h1 className="font-['Cormorant_Garamond'] text-3xl text-white">Admin Access</h1>
          <p className="text-zinc-500 text-sm mt-2">Dominican Upholstered</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-[#121212] border border-white/10 p-8 space-y-6" data-testid="login-form">
          {error && (
            <div className="p-3 bg-red-500/10 border border-red-500/30 text-red-400 text-sm" data-testid="login-error">
              {error}
            </div>
          )}
          <div>
            <label className="text-xs uppercase tracking-wider text-zinc-400 mb-2 block">Email</label>
            <Input
              type="email"
              className="bg-transparent border-white/20 text-white placeholder:text-zinc-500 focus-visible:ring-[#FFD700] h-12"
              placeholder="admin@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-zinc-400 mb-2 block">Password</label>
            <Input
              type="password"
              className="bg-transparent border-white/20 text-white placeholder:text-zinc-500 focus-visible:ring-[#FFD700] h-12"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full py-4 bg-[#FFD700] text-black font-medium uppercase tracking-wider text-sm hover:bg-[#E5C100] transition-all disabled:opacity-50"
            data-testid="login-submit"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="text-center mt-6">
          <a href="/" className="text-zinc-500 text-sm hover:text-[#FFD700] transition-colors">Back to website</a>
        </div>
      </div>
    </div>
  );
}
